import * as React from "react";
const SvgFiRrPanFood = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-pan-food_svg__a)">
      <path
        fill="#062147"
        d="m22.668 6.531.774-1.123a3.508 3.508 0 0 0-4.85-4.849l-1.123.774A11.9 11.9 0 0 0 12 .001C5.383 0 0 5.383 0 12c0 1.971.486 3.827 1.332 5.469l-.774 1.123a3.51 3.51 0 0 0 4.85 4.85l1.123-.774A11.9 11.9 0 0 0 12 24c6.617 0 12-5.383 12-12 0-1.971-.486-3.827-1.332-5.469M12 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10m3-4.5a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 15 17.5M6.5 12a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 6.5 12m5 1a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 11.5 13M15 8.5a1.5 1.5 0 1 1 3.001.001A1.5 1.5 0 0 1 15 8.5m-5 6.518v2.255c0 .446-.407.804-.843.712a4.08 4.08 0 0 1-3.142-3.142c-.092-.437.266-.843.712-.843h2.255c.562 0 1.018.456 1.018 1.018m8.365-3.51a4.01 4.01 0 0 1 0 4.327.71.71 0 0 1-1.095.106l-1.563-1.563a1 1 0 0 1 0-1.414l1.563-1.563a.71.71 0 0 1 1.095.106zM9 8.274V6.019c0-.562.456-1.018 1.018-1.018h2.255c.446 0 .804.407.712.843a4.08 4.08 0 0 1-3.142 3.142C9.406 9.078 9 8.72 9 8.274"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-pan-food_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPanFood;
